export default "__VITE_ASSET__CDH61LnD__"